import { observable, computed, action, IObservableArray } from "mobx";

import { CollectionStoreImpl } from "./CollectionStore";
import { WizardStore, IWizardStore } from "./AppStore";
import { Strings } from "../Stores/StringsStore";

export class CollectionPrivilegesWizardStore extends WizardStore implements IWizardStore {

	constructor(public collectionStore: CollectionStoreImpl) {
		super();
	}


	/**
  * Open the wizard for adding privileges to a collection.
  */
	open = (): void => {
		this.wizardCaption = Strings.documentManagement.collectionEdit.addPrivilegesCaption;
		this.wizardInformation = Strings.documentManagement.collectionEdit.addPrivilegesText;
		this.collectionStore.addPrivilegesMode = true;
		this.isOpen = true;
	}

	onConfirmExternal = () => {

	}

	/**
   * Callback for confirming the wizard operation.
   */
	@action onConfirmWizard = () => {
		this.collectionStore.saveSelectedPrivilege();
		this.isOpen = false;
		this.onConfirmExternal();
	}

	/**
	* Callback for canceling the wizard operation.
	*/
	@action onCancelWizard = () => {
		this.isOpen = false;
	}

}